// extracted by mini-css-extract-plugin
export default {"language__button":"LangButton_language__button__tUcoP"};